import React, { useState } from 'react';
import { FiGlobe, FiMoon, FiSun } from 'react-icons/fi';
import { useLanguage } from '../contexts/LanguageContext';

export default function AppearanceSettings() {
  const { language, setLanguage } = useLanguage();
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') === 'dark' ? 'dark' : 'light');
  const english = language === 'en';
  const changeTheme = (value) => {
    setTheme(value);
    document.documentElement.setAttribute('data-theme', value);
    localStorage.setItem('theme', value);
  };
  return (
    <div className="appearance-settings">
      <div className="appearance-settings-card">
        <span className="appearance-settings-heading"><FiSun size={16} />{english ? 'Appearance' : 'Giao diện'}</span>
        <div className="appearance-options" role="group" aria-label={english ? 'Appearance' : 'Giao diện'}>
          <button type="button" aria-pressed={theme === 'light'} onClick={() => changeTheme('light')}><FiSun size={17} />{english ? 'Light' : 'Sáng'}</button>
          <button type="button" aria-pressed={theme === 'dark'} onClick={() => changeTheme('dark')}><FiMoon size={17} />{english ? 'Dark' : 'Tối'}</button>
        </div>
      </div>
      <div className="appearance-settings-card">
        <span className="appearance-settings-heading"><FiGlobe size={16} />{english ? 'Language' : 'Ngôn ngữ'}</span>
        <div className="appearance-options" role="group" aria-label={english ? 'Language' : 'Ngôn ngữ'}>
          <button type="button" aria-pressed={language === 'vi'} onClick={() => setLanguage('vi')}><span className="appearance-language-code">VI</span>Tiếng Việt</button>
          <button type="button" aria-pressed={language === 'en'} onClick={() => setLanguage('en')}><span className="appearance-language-code">EN</span>English</button>
        </div>
      </div>
    </div>
  );
}
